const sulyBank: number[] = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7, 3, 1, 9, 7, 3];

function calcCDV(szla: string): boolean {
  let ncdv = 0;
  let a = 1;

  const ctemp = szla.substring(0, 8);

  for (a = 0; a < 8; a++) {
    ncdv += sulyBank[a] * parseInt(ctemp.substring(a, a + 1), 10);
  }

  if (ncdv % 10 !== 0) {
    return false;
  }
  return true;
}

export function isBlank(pString: string) {
  return !!(!pString || pString.length === 0 || pString === ' ');
}

/**
 * Adószám ellenőrzése, hibalehetőségek:
 * - Rossz a kapott érték hossza (pontosan 13 karakter lehet)
 * - A kapott érték nem csak számjegyet tartalmaz
 * - A 9. helyen nem 1, 2 vagy 3 szerepel (adómentes, adóköteles, EVA)
 * - Az utolsó két számjegy nem a következők egyike: 02-20, 22-44, 51
 * - A kapott érték CDV hibás
 */
export function checkTaxNumber(taxNum: string): boolean {
  let a = taxNum;
  if (isBlank(a) || a.length !== 13) {
    return false;
  }
  if (a.charAt(8) !== '-' || a.charAt(10) !== '-') {
    return false;
  }

  a = a.substring(0, 8) + a.substring(9, 10) + a.substring(11);
  const c = a.charAt(8);
  if (c < '1' || c > '5') {
    return false;
  }

  const i = parseInt(a.substring(9, 11), 10);
  if (i < 2 || i === 21 || (i > 44 && i !== 51)) {
    return false;
  }

  return calcCDV(a.substring(0, 8));
}

export function checkBankCdv(num: string) {
  if (isBlank(num) || num.length !== 8) {
    return false;
  }
  return calcCDV(num.substring(0, 8));
}

const checkIfAllTrue = (bool: boolean) => bool === true;

export function checkBankAccountCdv(szla: string) {
  const splitValue = szla.trim().split('-');

  const noSpaces = splitValue
    .map((part) =>
      part.replace(/\s/g, '').length ? part.replace(/\s/g, '').length === 8 : true
    )
    .every(checkIfAllTrue);
  if (!noSpaces) {
    return false;
  }

  const num = szla.replace(/-/g, '').trim();
  if (num.length !== 16 && num.length !== 24) {
    return false;
  }
  return calcCDV(num.substring(0, 16));
}

export function changeObjectNullValuesToEmptyString(object: Record<string, unknown>) {
  const newObject: Record<string, unknown> = {};
  Object.keys(object).map((key: string) => newObject[key] === object[key] ?? '');
  return newObject;
}
